import React from 'react';
import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import SocialShareOptions from '../../../components/SocialShareOptions';

const ShareGift = ({ onClose, claimUrl }) => {
  const theme = useTheme();

  return (
    <Modal onClose={onClose} width='430px'>
      <ParagraphLargeText style={{ color: theme.text.regular }}>
        Share gift with recipient
      </ParagraphLargeText>
      <BodyLarge style={{ margin: '10px 0px 10px 0px', textAlign: 'center' }}>
        Send the gift to the recipient to claim their gift card. The gift card
        can only be claimed once.
      </BodyLarge>
      <SocialShareOptions claimUrl={claimUrl} />
    </Modal>
  );
};

export default ShareGift;
